<div
  class="save-changes fixed bottom-0 left-0 flex w-full items-center justify-between border border-aux-gray-dark bg-aux-gray-light p-6 py-7 shadow"
  @upDownAnimation
>
  <span class="text-lg font-bold">You have unsaved changes.</span>

  <div>
    @if (showDiscardChangesBtn) {
      <button
        class="btn btn--secondary whitespace-nowrap text-sm font-normal"
        type="button"
        (click)="onDiscardChanges()"
      >
        <aux-icon name="X" />
        Discard Changes
      </button>
    }

    <button
      class="btn btn--success ml-4 whitespace-nowrap text-sm font-normal"
      type="button"
      (click)="onSaveChanges()"
      [auxTooltip]="saveChangesTooltip"
      [disabled]="saveChangesDisabled"
    >
      <aux-icon name="Check" />
      Save Changes
    </button>
  </div>
</div>
